import React from 'react';
import styled from 'styled-components';
import { Card as AntdCard } from 'antd';
import Button from 'components/Button/Button';
const StyledCardContainer = styled(AntdCard)`
  display: flex;
  justify-content: center;
`;
const StyledTitle = styled.p`
  font-size: large;
  font-weight: bold;
  color: black;
`;
const StyledHostStatus = styled.p`
  margin-bottom: 0px;
  color: ${props => props.theme.color.primary};
`;
const StyledBody = styled.p`
  margin-bottom: 0px;
  color: gray;
  padding-bottom: 10px;
`;
const StyleContentContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const LocationCard = ({ title, body, toUrl, onEnquireClick, hostStatus }) => (
  <StyledCardContainer>
    <StyleContentContainer>
      <StyledHostStatus>{hostStatus}</StyledHostStatus>
      <StyledTitle>{title}</StyledTitle>
      <StyledBody>{body}</StyledBody>
      <Button type="secondary" onClick={onEnquireClick}>
        Enquire Now
      </Button>
    </StyleContentContainer>
  </StyledCardContainer>
);

export default LocationCard;
